import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginViewModel } from '../models/loginViewModel';
import { catchError, Observable, of } from 'rxjs';
import { User } from '../models/user';
import { AuthService } from '../services/authService';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: false
})
export class LoginComponent {
  user = new User('', false);
  model = new LoginViewModel('', '', false);
  response?: any;
  errorList = document.createElement('ul');
  errorTitle?: string;
  emailErrorMsg?: string;
  passwordErrorMsg?: string;
  http!: HttpClient;
  isAuthenticated = false;
  userName?: string;
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  @ViewChild('loginForm') loginForm!: NgForm;
  @ViewChild('email', { static: false }) email!: ElementRef;
  @ViewChild('password', { static: false }) password!: ElementRef;
  @ViewChild('confirmPassword', { static: false }) confirmPassword!: ElementRef;

  constructor(
    http: HttpClient,
    private renderer: Renderer2,
    private router: Router,
    private authService: AuthService
  ) {
    this.http = http;
  }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
    if (isLoggedIn) {
      this.router.navigate(['/home']);
    }
  }

  ngAfterViewInit() {
    this.setFocusOnEmail();
    this.loginForm.form.updateValueAndValidity(); // Trigger validation check
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? '';
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private setFocusOnEmail(): void {
    let emailElem = document.getElementById('email') as HTMLInputElement;
    emailElem.focus();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  loginUser(): void {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    //debugger;
    this.http
      .post('/api/Account/login', this.model, {
        headers: headers,
      })
      .pipe(catchError(this.handleError<any>('loginUser')))
      .subscribe({
        next: (response) => {
          this.response = response;
          if (!response) {
            console.error('response is undefined');
          } else if (response?.success == false) {
            //update the UI to show the error
            const ul = this.renderer.createElement('ul');

            for (
              let errorMessage = 0;
              errorMessage < response.errorMessages.length;
              errorMessage++
            ) {
              const li = this.renderer.createElement('li');
              const text = this.renderer.createText(
                response.errorMessages[errorMessage]
              );
              this.renderer.appendChild(li, text);
              this.renderer.appendChild(this.errorList, li);
            }
          } else {
            // successfully registered user
            // redirect to home
            this.user.loggedin = response.isAuthenticated;
            this.user.username = response.userName ?? '';
            this.router.navigate(['/home']);
          }
        },
        error: (error) => {
          this.response = error;
          console.error(error.message);
        },
      });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error) {
        this.errorTitle = error.error.title;
      }
      for (let key in error.error.errors) {
        if (key.toLowerCase() == 'email') {
          this.emailErrorMsg = error.error.errors[key];
        }
        if (key.toLowerCase() == 'password') {
          this.passwordErrorMsg = error.error.errors[key];
        }
      }

      //debugger;
      return of(result as T);
    };
  }
}
